export const FETCH_COMPANY_NETWORK_USERS_REQUEST = 'FETCH_COMPANY_NETWORK_USERS_REQUEST';
export const FETCH_COMPANY_NETWORK_USERS_SUCCESS = 'FETCH_COMPANY_NETWORK_USERS_SUCCESS';
export const FETCH_COMPANY_NETWORK_USERS_FAIL = 'FETCH_COMPANY_NETWORK_USERS_FAIL';

export const FETCH_COMPANY_NETWORK_USER_DETAIL_REQUEST = 'FETCH_COMPANY_NETWORK_USER_DETAIL_REQUEST';
export const FETCH_COMPANY_NETWORK_USER_DETAIL_SUCCESS = 'FETCH_COMPANY_NETWORK_USER_DETAIL_SUCCESS';
export const FETCH_COMPANY_NETWORK_USER_DETAIL_FAIL = 'FETCH_COMPANY_NETWORK_USER_DETAIL_FAIL';

export const DELETE_COMPANY_NETWORK_USER_REQUEST = 'DELETE_COMPANY_NETWORK_USER_REQUEST';
export const DELETE_COMPANY_NETWORK_USER_SUCCESS = 'DELETE_COMPANY_NETWORK_USER_SUCCESS';
export const DELETE_COMPANY_NETWORK_USER_FAIL = 'DELETE_COMPANY_NETWORK_USER_FAIL';

export const INVITE_COMPANY_NETWORK_USER_REQUEST = 'INVITE_COMPANY_NETWORK_USER_REQUEST';
export const INVITE_COMPANY_NETWORK_USER_SUCCESS = 'INVITE_COMPANY_NETWORK_USER_SUCCESS';
export const INVITE_COMPANY_NETWORK_USER_FAIL = 'INVITE_COMPANY_NETWORK_USER_FAIL';

export const FETCH_COMPANY_NETWORK_SENT_INVITATION_REQUEST = 'FETCH_COMPANY_NETWORK_SENT_INVITATION_REQUEST';
export const FETCH_COMPANY_NETWORK_SENT_INVITATION_SUCCESS = 'FETCH_COMPANY_NETWORK_SENT_INVITATION_SUCCESS';
export const FETCH_COMPANY_NETWORK_SENT_INVITATION_FAIL = 'FETCH_COMPANY_NETWORK_SENT_INVITATION_FAIL';

export const FETCH_COMPANY_NETWORK_RECEIVED_INVITATION_REQUEST = 'FETCH_COMPANY_NETWORK_RECEIVED_INVITATION_REQUEST';
export const FETCH_COMPANY_NETWORK_RECEIVED_INVITATION_SUCCESS = 'FETCH_COMPANY_NETWORK_RECEIVED_INVITATION_SUCCESS';
export const FETCH_COMPANY_NETWORK_RECEIVED_INVITATION_FAIL = 'FETCH_COMPANY_NETWORK_RECEIVED_INVITATION_FAIL';

export const FETCH_COMPANY_NETWORK_CONNECTION_REQUEST = 'FETCH_COMPANY_NETWORK_CONNECTION_REQUEST';
export const FETCH_COMPANY_NETWORK_CONNECTION_SUCCESS = 'FETCH_COMPANY_NETWORK_CONNECTION_SUCCESS';
export const FETCH_COMPANY_NETWORK_CONNECTION_FAIL = 'FETCH_COMPANY_NETWORK_CONNECTION_FAIL';

export const ACCEPT_COMPANY_NETWORK_INVITATION_REQUEST = 'ACCEPT_COMPANY_NETWORK_INVITATION_REQUEST';
export const ACCEPT_COMPANY_NETWORK_INVITATION_SUCCESS = 'ACCEPT_COMPANY_NETWORK_INVITATION_SUCCESS';
export const ACCEPT_COMPANY_NETWORK_INVITATION_SUCCESS_NOTIFY = 'ACCEPT_COMPANY_NETWORK_INVITATION_SUCCESS_NOTIFY';
export const ACCEPT_COMPANY_NETWORK_INVITATION_FAIL = 'ACCEPT_COMPANY_NETWORK_INVITATION_FAIL';

export const REJECT_COMPANY_NETWORK_INVITATION_REQUEST = 'REJECT_COMPANY_NETWORK_INVITATION_REQUEST';
export const REJECT_COMPANY_NETWORK_INVITATION_SUCCESS = 'REJECT_COMPANY_NETWORK_INVITATION_SUCCESS';
export const REJECT_COMPANY_NETWORK_INVITATION_SUCCESS_NOTIFY = 'REJECT_COMPANY_NETWORK_INVITATION_SUCCESS_NOTIFY';
export const REJECT_COMPANY_NETWORK_INVITATION_FAIL = 'REJECT_COMPANY_NETWORK_INVITATION_FAIL';

export const SET_FAVORITE_COMPANY_NETWORK_USER_REQUEST = 'SET_FAVORITE_COMPANY_NETWORK_USER_REQUEST';
export const SET_FAVORITE_COMPANY_NETWORK_USER_SUCCESS = 'SET_FAVORITE_COMPANY_NETWORK_USER_SUCCESS';
export const SET_FAVORITE_COMPANY_NETWORK_USER_FAIL = 'SET_FAVORITE_COMPANY_NETWORK_USER_FAIL';

export const DELETE_COMPANY_NETWORK_CONNECTION_REQUEST = 'DELETE_COMPANY_NETWORK_CONNECTION_REQUEST';
export const DELETE_COMPANY_NETWORK_CONNECTION_SUCCESS = 'DELETE_COMPANY_NETWORK_CONNECTION_SUCCESS';
export const DELETE_COMPANY_NETWORK_CONNECTION_SUCCESS_NOTIFY = 'DELETE_COMPANY_NETWORK_CONNECTION_SUCCESS_NOTIFY';
export const DELETE_COMPANY_NETWORK_CONNECTION_FAIL = 'DELETE_COMPANY_NETWORK_CONNECTION_FAIL';

export const FETCH_COMPANY_NETWORK_CONTACTS_REQUEST = 'FETCH_COMPANY_NETWORK_CONTACTS_REQUEST';
export const FETCH_COMPANY_NETWORK_CONTACTS_SUCCESS = 'FETCH_COMPANY_NETWORK_CONTACTS_SUCCESS';
export const FETCH_COMPANY_NETWORK_CONTACTS_FAIL = 'FETCH_COMPANY_NETWORK_CONTACTS_FAIL';

export const BULK_ADD_COMPANY_NETWORK_CONTACTS_REQUEST = 'BULK_ADD_COMPANY_NETWORK_CONTACTS_REQUEST';
export const BULK_ADD_COMPANY_NETWORK_CONTACTS_SUCCESS = 'BULK_ADD_COMPANY_NETWORK_CONTACTS_SUCCESS';
export const BULK_ADD_COMPANY_NETWORK_CONTACTS_FAIL = 'BULK_ADD_COMPANY_NETWORK_CONTACTS_FAIL';

export const DELETE_COMPANY_NETWORK_CONTACT_REQUEST = 'DELETE_COMPANY_NETWORK_CONTACT_REQUEST';
export const DELETE_COMPANY_NETWORK_CONTACT_SUCCESS = 'DELETE_COMPANY_NETWORK_CONTACT_SUCCESS';
export const DELETE_COMPANY_NETWORK_CONTACT_FAIL = 'DELETE_COMPANY_NETWORK_CONTACT_FAIL';